/**
 * Full-screen error shown when the platform Worker is unreachable or not
 * configured. It is intentionally explicit: no fake client, no retry loops
 * against a guessed URL.
 */
export function ConfigError({ message }: { message: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-6">
      <div className="w-full max-w-xl rounded-xl border border-red-200 bg-white p-6 shadow-sm">
        <h1 className="text-lg font-semibold text-red-700">adop is not configured</h1>
        <p className="mt-3 text-sm text-zinc-700">{message}</p>
        <div className="mt-4 rounded-lg bg-zinc-50 p-3 text-xs text-zinc-600">
          <p className="font-medium text-zinc-800">How to fix</p>
          <ol className="mt-1 list-decimal space-y-1 pl-4">
            <li>
              Local development: run <code className="rounded bg-zinc-200 px-1">./start.sh</code>{' '}
              from the repo root, then reload this page.
            </li>
            <li>
              Production: set the Worker secrets listed in{' '}
              <code className="rounded bg-zinc-200 px-1">docs/configuration.md</code>, then check{' '}
              <code className="rounded bg-zinc-200 px-1">/api/platform/health</code>.
            </li>
          </ol>
        </div>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-5 inline-flex items-center rounded-lg bg-zinc-900 px-4 py-2 text-sm font-medium text-white hover:bg-zinc-800"
        >
          Retry
        </button>
      </div>
    </div>
  );
}
